import { FC } from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import { isLoggedIn } from "../utils/utility";

const ProtectedRoute: FC<{ children: JSX.Element }> = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return children;
};

export default ProtectedRoute;
